<template>
  <!-- eslint-disable vue/no-deprecated-v-bind-sync -->
  <div class="coupon-data-page">
    <div class="page-header">
      <span class="title">优惠券数据</span>
    </div>

    <div class="summary-card">
      <div class="summary-update-time">
        每半小时更新一次，最近更新时间：{{ latestUpdateTime }}
      </div>
      <div class="summary-grid">
        <div v-for="item in summaryList" :key="item.key" class="summary-item">
          <div class="summary-label">{{ item.label }}</div>
          <div class="summary-value">{{ item.value }}</div>
        </div>
      </div>

      <el-tabs v-model="activeTab" class="record-tabs">
        <el-tab-pane label="发放领取记录" name="grant"></el-tab-pane>
        <el-tab-pane label="核销记录" name="verify"></el-tab-pane>
      </el-tabs>
      <!-- eslint-disable-next-line vue/no-unused-refs -->
      <base-list-management
        :key="activeTab"
        ref="baseListManagementRef"
        :configData.sync="configData"
      >
        <template v-slot:custom-export>
          <PublicExport
            :key="currentExportTemplateCode"
            :exportTitle="currentExportTitle"
            :exportTemplate="currentExportTemplate"
            :getSearchData="getExportParams"
            :templateCode="currentExportTemplateCode"
            :getSearchCondition="getSearchCondition"
          >
            <template v-slot:export-button="{ openDialog, exportBtnText }">
              <el-button type="primary" size="small" @click="openDialog">
                {{ exportBtnText }}
              </el-button>
            </template>
          </PublicExport>
        </template>
      </base-list-management>
    </div>
    <DeductionDetailDialog
      :visible.sync="deductionDialog.visible"
      :middleSubOrderId="currentMiddleSubOrderId"
    />
  </div>
</template>

<script>
import {
  couponTemplateStatistics,
} from '@/api/domain/activity'
import DeductionDetailDialog from './components/DeductionDetailDialog.vue'
import { configDataFn } from '../config/grantRecordList'
import { generateExportCondition } from '@/utils/exportUtils.js'

const EXPORT_CONFIG_MAP = {
  grant: {
    title: '发放领取记录导出',
    template: 'CouponUserGet',
    templateCode: 'vehicle-customer-get-coupon-page',
  },
  verify: {
    title: '核销记录导出',
    template: 'CouponUserVerify',
    templateCode: 'vehicle-customer-verify-coupon-page',
  },
}

export default {
  name: 'CouponGrantRecord',
  components: {
    DeductionDetailDialog,
  },
  data() {
    const couponTemplateId = this.$route.query.activityId || ''
    const queryTab = String(this.$route.query.tab || '').toLowerCase()
    const activeTab = queryTab === 'verify' ? 'verify' : 'grant'
    const initialFormData = {}
    if (this.$route.query.couponId !== undefined && this.$route.query.couponId !== null) {
      initialFormData.couponId = String(this.$route.query.couponId)
    }
    return {
      couponTemplateId,
      activeTab,
      configData: configDataFn({
        activeTab,
        couponTemplateId,
        showGrantUserIdFilter: true,
        hideVerifySourceFilter: true,
        hideCouponTemplateFields: true,
        hideVerifyCouponTemplateFields: true,
        initialFormData,
        onShowDeductionDetail: this.handleShowDeductionDetail,
        onJumpDriverList: this.handleJumpDriverList,
        onJumpCouponActivity: this.handleJumpCouponActivity,
        onJumpOrderList: this.handleJumpOrderList,
        createElement: this.$createElement,
      }),
      currentMiddleSubOrderId: '',
      deductionDialog: {
        visible: false,
      },
      latestUpdateTime: '2026-03-23 10:30:00',
      summaryData: {
        stockTotal: 0,
        leftTotal: 0,
        grantUserNum: 0,
        useUserNum: 0,
        useTotal: 0,
      },
    }
  },
  created() {
    this.getCouponTemplateStatistics()
  },
  computed: {
    currentExportConfig() {
      return EXPORT_CONFIG_MAP[this.activeTab] || EXPORT_CONFIG_MAP.grant
    },
    currentExportTitle() {
      return this.currentExportConfig.title
    },
    currentExportTemplate() {
      return this.currentExportConfig.template
    },
    currentExportTemplateCode() {
      return this.currentExportConfig.templateCode
    },
    summaryList() {
      return [
        { key: 'stockTotal', label: '总库存', value: this.summaryData.stockTotal },
        { key: 'leftTotal', label: '剩余总数', value: this.summaryData.leftTotal },
        { key: 'grantUserNum', label: '发券用户数(人)', value: this.summaryData.grantUserNum },
        { key: 'useUserNum', label: '用券用户数(人)', value: this.summaryData.useUserNum },
        { key: 'useTotal', label: '核销数量', value: this.summaryData.useTotal },
      ]
    },
  },
  watch: {
    activeTab() {
      const initialFormData = {}
      if (
        this.activeTab === 'verify'
        && this.$route.query.couponId !== undefined
        && this.$route.query.couponId !== null
      ) {
        initialFormData.couponId = String(this.$route.query.couponId)
      }
      this.configData = configDataFn({
        activeTab: this.activeTab,
        couponTemplateId: this.$route.query.activityId || '',
        showGrantUserIdFilter: true,
        hideVerifySourceFilter: true,
        hideCouponTemplateFields: true,
        hideVerifyCouponTemplateFields: true,
        initialFormData,
        onShowDeductionDetail: this.handleShowDeductionDetail,
        onJumpDriverList: this.handleJumpDriverList,
        onJumpCouponActivity: this.handleJumpCouponActivity,
        onJumpOrderList: this.handleJumpOrderList,
        createElement: this.$createElement,
      })
    },
  },
  methods: {
    formatTs(ts) {
      if (ts === undefined || ts === null || ts === '') return ''
      const num = Number(ts)
      if (Number.isNaN(num)) return ''
      const ms = String(Math.trunc(num)).length === 10 ? num * 1000 : num
      const d = new Date(ms)
      const pad = (n) => String(n).padStart(2, '0')
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
    },
    async getCouponTemplateStatistics() {
      if (!this.couponTemplateId) return
      const { code, data = {}, ts } = await couponTemplateStatistics({
        id: this.couponTemplateId,
      })
      if (code !== 1) return
      const summary = data || {}
      this.summaryData = {
        stockTotal: summary.totalStock || 0,
        leftTotal: summary.residualStock || 0,
        grantUserNum: summary.totalUserNum || 0,
        useUserNum: summary.useUserNum || 0,
        useTotal: summary.verifyNum || 0,
      }
      this.latestUpdateTime = this.formatTs(ts) || this.latestUpdateTime
    },
    getExportParams() {
      if (!this.$refs.baseListManagementRef) return {}
      return this.$refs.baseListManagementRef.getParams()
    },
    getSearchCondition() {
      const formList = this.configData?.formData?.list || []
      const model = this.configData?.formData?.formProps?.model || {}
      const condition = formList.map((item) => {
        const { el, itemConfig: { label, prop: key } } = item
        const val = model[key]
        const { matchValue, hidden } = generateExportCondition[el](val, item)
        return {
          label,
          key,
          matchValue,
          hidden,
        }
      })
      condition.push({
        label: '记录类型',
        matchValue: this.activeTab === 'grant' ? '发放领取记录' : '核销记录',
      })
      return condition
    },
    handleShowDeductionDetail(row) {
      const { middleSubOrderId } = row
      if (!middleSubOrderId || middleSubOrderId === '--') {
        this.$message.warning('缺少中台子单ID，无法查询抵扣明细')
        return
      }
      this.currentMiddleSubOrderId = middleSubOrderId
      this.deductionDialog.visible = true
    },
    handleJumpDriverList(customerName) {
      this.$router.push({
        path: '/driver/customerManage',
        query: {
          type: 'person',
          customerName,
        },
      })
    },
    handleJumpCouponActivity(activityId) {
      this.$router.push({
        path: '/activity/coupon/list',
        query: {
          activityId,
        },
      })
    },
    handleJumpOrderList(orderId) {
      this.$router.push({
        path: '/workbench/rentOrder/detail',
        query: {
          id: String(orderId),
          orderType: 'personal',
        },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.coupon-data-page {
  padding: 16px;
}

.page-header {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
}

.summary-card {
  background: #fff;
  border-radius: 4px;
  padding: 16px 20px;
}

.summary-update-time {
  color: #606266;
  font-size: 13px;
  margin-bottom: 16px;
}

.summary-grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(120px, 1fr));
  gap: 8px;
  margin-bottom: 8px;
}

.summary-item {
  text-align: center;
  padding: 8px 0;
}

.summary-label {
  color: #606266;
  font-size: 13px;
  margin-bottom: 8px;
}

.summary-value {
  color: #303133;
  font-size: 30px;
  font-weight: 700;
  line-height: 1.2;
}

.record-tabs {
  margin-top: 8px;
}

.search-form {
  margin-top: 8px;
}

.record-table {
  margin-top: 8px;
}
</style>
